<div class="container-fluid p-3 h-100">
  <div class="alert alert-dark text-center" role="alert" *ngIf="!chatEngineConnected">
    {{ 'CHAT_WAITING_FOR_ENGINE_CONNECTION' | translate }}
  </div>
  <div class="py-4 heading-container">
    <div class="d-inline-block align-middle me-2 mb-2">
      <img class="chat-icon" src="assets/icons/icon-messages-chat.svg" alt="" />
    </div>
    <h1 class="d-inline-block align-middle m-0 mb-2" data-test-id="chat-title">
      {{ 'CHAT_TITLE_MESSAGES' | translate }}
    </h1>
    <button
      class="ms-3 mb-2 btn btn-outline-primary"
      type="button"
      [disabled]="!chatEngineConnected"
      data-test-id="new-msg-btn"
      (click)="initNewMessage()"
    >
      {{ 'CHAT_INIT_NEW_MSG_HINT' | translate }}
    </button>
  </div>
  <div *ngIf="conversations && conversations.length === 0">
    <h1 class="text-muted" data-test-id="no-conversations-title">
      {{ 'CHAT_NO_CONVERSATIONS_HINT' | translate }}
    </h1>
  </div>
  <div *ngIf="!conversations">
    <div class="spinner-grow text-primary" role="status">
      <span class="sr-only">{{ 'LOADING_HINT' | translate }}</span>
    </div>
  </div>
  <div class="chat-holder">
    <app-chat-tabs
      [ngClass]="activeConversationId ? 'hide-section' : 'show-section'"
      [conversations]="conversations"
      [currentUserId]="currentUserId"
      [activeConversationId]="activeConversationId"
      (conversationSelected)="onConversationSelected($event)"
    ></app-chat-tabs>
    <app-chat-content
      [ngClass]="activeConversationId ? 'show-section' : 'hide-section'"
      [class.project-chat-content]="false"
      [titleConfiguration]="titleConfiguration"
      [messages]="messages"
      [currentUserId]="currentUserId"
      [isLoadingMessages]="isLoadingMessages"
      [displayAccountStatusHint]="displayAccountStatusHint"
      [accountStatusHint]="accountStatusHint"
      [activeConversation]="activeConversation"
      [memberTypingName]="memberTypingName"
      [channelExists]="channelExists"
      [permissions]="permissions"
      (backBtnClick)="onBackBtnClick()"
      (blockUser)="blockUser()"
      (scrolledToTop)="loadMoreMessages()"
      (sendTextMessage)="onSendTextMessage($event)"
      (messageEdited)="onMessageEdited($event)"
      (messageRemoved)="onRemoveMessage($event)"
      (userTyping)="onUserTyping()"
      (conversationTitleEditRequested)="onConversationTitleEditRequested()"
      (dirtyForm)="setFormStatus($event)"
    ></app-chat-content>
  </div>
</div>
